import { action, computed, observable } from "mobx";
import { StoreBase } from "./storeBase";
import {
  AssertionAnswers,
  AssertionType,
  defaultPostAttestation,
  defaultPostAttestationAnswers,
  PostAttestation,
} from "domain/assertions";
import { ApplicationError } from "domain/error";
import { generateApplicationError } from "domain/hardstop";
import { Nullable } from "util/extendedTypes";

export class AttestationStore extends StoreBase<PostAttestation> {
  constructor() {
    super(() => defaultPostAttestation());
  }

  @observable
  applicationError: Nullable<ApplicationError> = null;

  @computed
  public get answers(): AssertionAnswers {
    return this.data || defaultPostAttestationAnswers();
  }

  @computed
  public get hardStoppedOnUI(): boolean {
    return this.data?.hardStoppedOnUI || false;
  }
  @action
  submitPostAttestations = (
    postAttestation: PostAttestation
  ): PostAttestation => {
    return (this.data = postAttestation);
  };

  @action
  generateError = (type: AssertionType): ApplicationError => {
    this.applicationError = generateApplicationError(type);
    return this.applicationError;
  };
}
